import { render, staticRenderFns } from "./UpdatePrices.vue?vue&type=template&id=0c31fc6c&scoped=true"
import script from "./UpdatePrices.vue?vue&type=script&lang=js"
export * from "./UpdatePrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31fc6c",
  null
  
)

export default component.exports